import { Injectable } from '@angular/core';
import { ArgsInterface, LanguageType, TranslationStrings } from '@monsido_services/services/mon-translate/dist/translate.interface';
import { TranslateService as MonTranslateService } from '@monsido_services/services/mon-translate/dist/translate.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class TranslateService {

    private service = new MonTranslateService();

    get baseLanguage (): LanguageType {
        return this.service.baseLanguage;
    }

    constructor () { }

    onLanguageChange$ (): Observable<string> {
        return this.service.onLanguageChange$();
    }

    getString (text: string, args: ArgsInterface = {}, context?: string): string {
        return this.service.getString(text, args, context);
    }

    getPlural (n: number, text: string, textPlural: string, args: ArgsInterface, context: string): string {
        const res = this.service.getPlural(
            n,
            text,
            textPlural,
            args,
            context,
        );
        // the key is synced with {{ }} variable format -> needs to interpolate with {{ instead of [[
        if (res.includes('{{')) {
            if (args) {
                args['$count'] = n;
            }
            return this.interpolateForOldFormat(res, args);
        }
        return res;
    }

    setCurrentLanguage (lang: LanguageType): void {
        this.service.setCurrentLanguage(lang);
    }

    setStrings (language: LanguageType, strings: TranslationStrings): void {
        this.service.setStrings(language, strings);
    }

    interpolateForOldFormat (str: string, args: ArgsInterface): string {
        if (str && Object.keys(args).length > 0) {
            for (const key in args) {
                if (args.hasOwnProperty(key)) {
                    str = str.replace('{{' + key + '}}', args[key] as string);
                }
            }
        }
        return str;

    }
}
